module.exports = __webpack_public_path__ + "img/kachel-STRESS_COLOSTRUMLIQUID.e2e46172.png";